<template>
  <v-container style="padding: 0">
    <iframe
      width="100%"
      height="480"
      :src="'https://www.youtube.com/embed/' + obj.task.taskDesc.split('=')[1]"
      frameborder="0"
      allow="autoplay; encrypted-media"
      allowfullscreen
    ></iframe>
  </v-container>
</template>

<script>
export default {
  name: "youtubeDetail",
  props: {
    obj: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
